// Klinik geneli listede seçilen kaydın editörünü sağdan açan drawer.
// Başlık: hasta adı + kayıt özeti. Yetki yoksa üstte "yalnız görüntüleme" notu.
// Altta "Kapat" + hasta detayına giden "Hastaya git" (yalnız patients:read yetkisiyle).

import useTerms from "../../../hooks/useTerms";
import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Drawer, Typography } from "@mui/material";
import { LockOutlined as LockIcon, ArrowForward as ArrowForwardIcon } from "@mui/icons-material";
import { DrawerHeader, DrawerFooter } from "../../atoms";
import { useHasPermission } from "../../../hooks/useHasPermission";
import { COLORS, TYPO } from "../../../styles/uiConstants";

/**
 * @param {string} [patientLink] - hasta detayı yolu (ör. `/Hastalar/<id>?tab=tedaviler&kayit=<id>`)
 */
export default function RecordEditorDrawer({ open, onClose, icon, title, subtitle, readOnly, patientLink, children }) {
  const terms = useTerms();
  const navigate = useNavigate();
  const canOpenPatient = useHasPermission("patients:read");
  const showPatientLink = Boolean(patientLink) && canOpenPatient;

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: { width: { xs: "100%", sm: 560 }, display: "flex", flexDirection: "column", bgcolor: COLORS.white },
      }}
    >
      <DrawerHeader icon={icon} title={title} subtitle={subtitle} onClose={onClose} />

      {readOnly && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            mx: 2,
            mt: 1.5,
            px: 1.5,
            py: 1,
            borderRadius: 2,
            bgcolor: COLORS.slate50,
            border: `1px solid ${COLORS.slate200}`,
          }}
        >
          <LockIcon sx={{ fontSize: 16, color: COLORS.slate500 }} />
          <Typography sx={{ fontSize: TYPO.caption, color: COLORS.slate600 }}>
            Yalnızca görüntüleme — düzenleme yetkiniz yok
          </Typography>
        </Box>
      )}

      <Box sx={{ flex: 1, minHeight: 0, overflow: "hidden", p: 1 }}>{children}</Box>

      <DrawerFooter
        onCancel={onClose}
        cancelLabel="Kapat"
        onSubmit={showPatientLink ? () => navigate(patientLink) : undefined}
        submitLabel={`${terms.patientDat} git`}
        startIcon={<ArrowForwardIcon />}
        fullWidth
      />
    </Drawer>
  );
}
